import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, catchError, of } from 'rxjs';
import { invalidOperationLobbyErrorCodes, permissionLobbyErrorCodes } from 'src/app/infrastructure/lobby-proxy/enums/lobby-error-code.enum';
import { LobbyErrors } from 'src/app/core/models/common/lobby-error.model';
import { ErrorAction } from '../events/error.actions';

@Injectable({
  providedIn: 'root'
})
export class LobbyErrorHandlerService {

  constructor(private store: Store) { }

  readonly handleError = <T>(obs$: Observable<T>): Observable<T> => {
    return obs$.pipe(
      catchError(error => {
        console.error('error', error)

        if (error['errors']) { // Is lobby Error

          // Invalid operation
          if ((error as LobbyErrors).errors.filter(e => e.code).some(e => invalidOperationLobbyErrorCodes.includes(e.code!)))
            this.store.dispatch(ErrorAction.invalidOperationError(error as LobbyErrors))

          // Permissions
          else if ((error as LobbyErrors).errors.filter(e => e.code).some(e => permissionLobbyErrorCodes.includes(e.code!)))
            this.store.dispatch(ErrorAction.forbiddenOperationError(error as LobbyErrors))

          else this.store.dispatch(ErrorAction.genericError(error.message as string))
        }
        else this.store.dispatch(ErrorAction.unkonwnError())

        return of(error)
      }),

    )
  }
}
